export const environment = {
  production: false,
  apiBaseUrl: "https://devcustomer.servicegalaxy.com:3006/",
  bucketurl: 'https://service-galaxy-dev.s3.us-east-2.amazonaws.com',
  bucketname: "service-galaxy-dev",
  googleMapsApiKey: "AIzaSyC2UyybrDbece03B9gLCOc1mFlRIrG7bgk",
  firebase: {
    apiKey: "AIzaSyBPLQzzcxnw4qKYV7WmkCKSy6AnnF3gMIk",
    authDomain: "service-galaxy.firebaseapp.com",
    databaseURL: "https://service-galaxy-default-rtdb.firebaseio.com",
    projectId: "service-galaxy",
    storageBucket: "service-galaxy.firebasestorage.app",
    messagingSenderId: "466475764062",
    appId: "1:466475764062:web:73dc8cc4354c54dd9467cf",
    measurementId: "G-JVZL9QCTSJ"
  }
};